<template>
<div class="swiper-slide-inner">
    <div class="step">
        <p>プライススクリーニング STEP<span>03</span></p>
    </div>
    <div class="card">
        <div class="card-inner">

            <div class="question-wrap">
                <h3><span>商品の平均の価格帯を教えてください。</span></h3>
                <p></p>
            </div>

            <div class="item-wrap" v-for="(categoriyLv3,index) in categoriyLv3List" v-bind:key="index">
                <div class="item form_select">
                    <select id="sel_price_zone" v-on:change="selectPriceZoneGuideline($event, categoriyLv3.price_zone_guidelines)">
                        <option value="" hidden>選択して下さい</option>
                        <option 
                            v-for="price_zone_guideline in categoriyLv3.price_zone_guidelines"
                            v-bind:key="price_zone_guideline.id"
                            v-bind:value="price_zone_guideline.id">
                            {{ price_zone_guideline.price_range }}
                        </option>
                    </select>
                    <label for="company-genre"><span>{{categoriyLv3.name}}の価格帯は？</span></label>
                </div>
            </div>
        </div>

        <div class="control-wrap">
            <button type="button" class="_left js-swiper-prev" v-on:click="swiperBack3()"><span>Back</span></button>
            <button type="button" class="_right js-swiper-next" v-on:click="confirmIn()"><span>審査登録する</span></button>
        </div>

    </div>
</div>
<AlertModal 
    v-if="showAlertModal" 
    @close="closeAlertModal" 
    :title="alert_modal_title" 
    :message="alert_modal_message"
    :mode="alert_modal_mode" 
/>
</template>


<script>
    import AlertModal from '@/components/EndUser/ComponentList/AlertModal'

    export default {
        components: {
            "AlertModal": AlertModal,
        },
        data() {
            return {
                isDisabled: false,
                select_price_zone_guidelines: [],
                showAlertModal: false,
                alert_modal_title: '',
                alert_modal_message: '',
                alert_modal_mode: ''
            }
        },
        computed: {
            categoriyLv3List (){
                return this.$store.state.register.form.select_priceZone_categoriyLv2;
            }
        },
        mounted() {
        },
        methods: {
            selectPriceZoneGuideline: function (event, price_zone_guidelines) {
                var price_zone_guideline_id = event.target.value;

                var value = price_zone_guidelines.filter((price_zone_guideline) => {
                    return (price_zone_guideline.id == price_zone_guideline_id);
                });

                if (value[0].second_id) {
                    
                    for(var i in this.select_price_zone_guidelines) {
                        var select_price_zone_guideline = this.select_price_zone_guidelines[i];
                        if (select_price_zone_guideline.second_id == value[0].second_id) {
                            this.select_price_zone_guidelines.splice(i, 1)
                        }
                    }
                    this.select_price_zone_guidelines.push(value[0]);
                } else {
                    for(var i in this.select_price_zone_guidelines) {
                        var select_price_zone_guideline = this.select_price_zone_guidelines[i];
                        if (select_price_zone_guideline.third_id == value[0].third_id) {
                            this.select_price_zone_guidelines.splice(i, 1)
                        }
                    }
                    this.select_price_zone_guidelines.push(value[0]);
                }
                if (this.select_price_zone_guidelines.length == 0) {
                    this.select_price_zone_guidelines.push(value[0]);
                }

                this.$store.state.register.form.select_price_zone_guidelines = this.select_price_zone_guidelines;
            },
            confirmIn: function () {
                let validate = false;
                if (this.select_price_zone_guidelines.length == this.$store.state.register.form.select_priceZone_categoriyLv2.length) {
                    validate = true;
                }

                if (!validate) {
                    this.openAlertModal("error", 'エラー', '必須項目を入力してください。'); // 確認済み
                } else {
                    //Swiperをフェードアウト
                    $('.swiper-container').addClass('_hidden');
                    setTimeout(() => {
                        //Swiperをdisplay:none;
                        $('.swiper-container').addClass('_none');
                    }, 200);

                    $('.btn_examination-wrap').removeClass('_show');
                    $('.dply_detail-page').removeClass('_show');
                    $('.preview-label-wrap').removeClass('_show');
                    setTimeout(() => {
                        $('.dply_detail-page').removeClass('_block');
                        $('.examination-completion').addClass('_block');
                    }, 800);
                    setTimeout(() => {
                        $('.examination-completion').addClass('_show');
                    }, 850);

                    this.$emit('showConfirm');
                }
            },
            swiperBack3() {
                $("select option").attr("selected", false);
                $("select").val("");
                this.select_price_zone_guidelines = [];
                this.$store.state.register.form.select_price_zone_guidelines = [];
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = "";
                this.alert_modal_title = "";
                this.alert_modal_message = "";
            }
        }
    }
</script>